// Audio + vibration feedback for time-sensitive tournament events.
// Runs entirely in-browser (no asset downloads). Designed for PWA use.

const VIBRATION_PATTERNS = {
  tournament_starting_soon: [200, 100, 200],
  tournament_ending_soon: [300, 120, 300, 120, 300],
  tournament_ended: [500, 200, 500, 200, 500],
  geofence_breach: [400, 100, 400, 100, 400, 100, 400],
};

const TONE_SEQUENCES = {
  tournament_starting_soon: [
    { freq: 880, dur: 180 },
    { freq: 1100, dur: 220 },
  ],
  tournament_ending_soon: [
    { freq: 660, dur: 160 },
    { freq: 660, dur: 160 },
    { freq: 660, dur: 220 },
  ],
  tournament_ended: [
    { freq: 523, dur: 200 },
    { freq: 392, dur: 240 },
    { freq: 330, dur: 360 },
  ],
  geofence_breach: [
    { freq: 1200, dur: 140 },
    { freq: 800, dur: 140 },
    { freq: 1200, dur: 140 },
    { freq: 800, dur: 220 },
  ],
};

let sharedAudioCtx = null;

function getAudioContext() {
  if (typeof window === "undefined") return null;
  if (!sharedAudioCtx) {
    try {
      const Ctor = window.AudioContext || window.webkitAudioContext;
      if (!Ctor) return null;
      sharedAudioCtx = new Ctor();
    } catch {
      return null;
    }
  }
  if (sharedAudioCtx.state === "suspended") {
    sharedAudioCtx.resume().catch(() => {});
  }
  return sharedAudioCtx;
}

// iOS Safari requires audio to be initialized during a user gesture.
// Call this from a pointer/key handler the first time.
export function primeTournamentAlertAudio() {
  const ctx = getAudioContext();
  if (!ctx) return;
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    gain.gain.setValueAtTime(0.0001, ctx.currentTime);
    osc.connect(gain).connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + 0.01);
  } catch {}
}

function playTones(tones) {
  const ctx = getAudioContext();
  if (!ctx) return;
  let t = ctx.currentTime;
  for (const tone of tones) {
    try {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.setValueAtTime(tone.freq, t);
      gain.gain.setValueAtTime(0, t);
      gain.gain.linearRampToValueAtTime(0.3, t + 0.015);
      gain.gain.linearRampToValueAtTime(0, t + tone.dur / 1000);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + tone.dur / 1000 + 0.05);
    } catch {}
    t += tone.dur / 1000 + 0.06;
  }
}

export function triggerTournamentAlertFeedback({
  eventType,
  sound = true,
  vibrate = true,
} = {}) {
  const key = String(eventType || "").trim();
  if (!key) return;

  if (vibrate && typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
    const pattern = VIBRATION_PATTERNS[key];
    if (pattern) {
      try {
        navigator.vibrate(pattern);
      } catch {}
    }
  }

  if (sound) {
    const tones = TONE_SEQUENCES[key];
    if (tones) {
      playTones(tones);
    }
  }
}
